module.exports = __webpack_public_path__ + "2fd9581bca42b76045c5d53d23d952b9.pdf";